"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/page-header/style/css");
var page_header_1 = __importDefault(require("antd/lib/page-header"));
require("antd/lib/card/style/css");
var card_1 = __importDefault(require("antd/lib/card"));
require("antd/lib/descriptions/style/css");
var descriptions_1 = __importDefault(require("antd/lib/descriptions"));
require("antd/lib/typography/style/css");
var typography_1 = __importDefault(require("antd/lib/typography"));
require("antd/lib/button/style/css");
var button_1 = __importDefault(require("antd/lib/button"));
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var icons_1 = require("@ant-design/icons");
var utils_1 = require("../../utils");
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var FeedbackDetailView = /*#__PURE__*/ react_1.default.memo(function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _useParams = (0, react_router_dom_1.useParams)(), feedbackID = _useParams.id;
    var feedback = (0, react_redux_1.useSelector)(function (state) {
        return (0, utils_1.findItemByID)(state.feedback.items, feedbackID);
    });
    if (!feedback)
        return "Loading...";
    var feedbackDate = Date.parse(feedback.submitted);
    return (0, jsx_runtime_1.jsxs)(page_header_1.default, {
        ghost: false,
        onBack: function onBack() {
            return navigate(-1);
        },
        title: (0, jsx_runtime_1.jsxs)("span", {
            children: ["Feedback from ", feedbackDate.toLocaleString()]
        }),
        extra: [(0, jsx_runtime_1.jsx)(button_1.default, {
                icon: (0, jsx_runtime_1.jsx)(icons_1.EditOutlined, {}),
                onClick: function onClick() {
                    return navigate("edit/".concat(feedbackID));
                },
                children: "Edit"
            }, "edit")],
        children: [(0, jsx_runtime_1.jsxs)(typography_1.default.Title, {
                level: 2,
                children: ["Feedback from ", feedback.from.name]
            }), (0, jsx_runtime_1.jsxs)(descriptions_1.default, {
                bordered: true,
                size: "small",
                children: [(0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                        label: "From Name",
                        children: feedback.from.name
                    }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                        label: "Menu Icon",
                        children: feedback.from.email
                    }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                        label: "Time Submitted",
                        children: feedbackDate.toLocaleString()
                    })]
            }), (0, jsx_runtime_1.jsx)(card_1.default, {
                size: "small",
                title: "Content",
                style: {
                    marginTop: 16
                },
                children: feedback.content
            })]
    });
});
exports.default = FeedbackDetailView;
